export default __webpack_public_path__ + "static/media/delete-btn.e605c0f3.svg";